// Baseline onboarding flow

// ============================================
// Import baseline pages
// ============================================
import AlcoholPage from './AlcoholPage'
import BiologicalSexPage from './BiologicalSexPage'
import BirthYearPage from './BirthYearPage'
import BloodGlucosePage from './BloodGlucosePage'
import BloodPressurePage from './BloodPressurePage'
import CancerScreeningsPage from './CancerScreeningsPage'
import ChildrenPage from './ChildrenPage'
import CholesterolPage from './CholesterolPage'
import CountryPage from './CountryPage'
import DoctorCheckupsPage from './DoctorCheckupsPage'
import ExerciseFrequencyPage from './ExerciseFrequencyPage'
import FruitsAndVeggiesPage from './FruitsAndVeggiesPage'
import GrandparentsLifespanPage from './GrandparentsLifespanPage'
import HabitsIntroPage from './HabitsIntroPage'
import HealthcareIntroPage from './HealthcareIntroPage'
import HeightPage from './HeightPage'
import IncomeLevelPage from './IncomeLevelPage'
import JobPage from './JobPage'
import LivingLocationPage from './LivingLocationPage'
import NutritionIntroPage from './NutritionIntroPage'
import ProcessedFoodPage from './ProcessedFoodPage'
import RelationshipStatusPage from './RelationshipStatusPage'
import RunningDifficultyPage from './RunningDifficultyPage'
import SittingTimePage from './SittingTimePage'
import SleepHoursPage from './SleepPage'
import SleepTroublePage from './SleepTroublePage'
import SmokingPage from './SmokingPage'
import SocialLifeIntroPage from './SocialLifeIntroPage'
import SocialTimePage from './SocialTimePage'
import StressPage from './StressPage'
import SugarIntakePage from './SugarIntakePage'
import SunProtectionPage from './SunProtectionPage'
import WaterIntakePage from './WaterIntakePage'
import WeightPage from './WeightPage'

import navigateToNextOnboardingPageAction from '@actions/navigateToNextOnboardingPageAction'
import skipOnboardingLoader from '@app-studio-web/ui/loaders/skipOnboardingLoader'

import { Outlet } from 'react-router-dom'

const onboardingRoutes = [
  {
    path: '',
    element: <Outlet />,
    loader: skipOnboardingLoader,
    children: [
      // ============================================
      // OPENING (6 pages) - biological-sex first
      // ============================================
      {
        action: navigateToNextOnboardingPageAction,
        element: <BiologicalSexPage />,
        path: 'start',
      },
      {
        // Accessible directly for mobile settings (e.g. ?mode=update)
        action: navigateToNextOnboardingPageAction,
        element: <BiologicalSexPage />,
        path: 'biological-sex',
        handle: { skipInNavigation: true },
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <BirthYearPage />,
        path: 'birth-year',
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <CountryPage />,
        path: 'country',
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <WeightPage />,
        path: 'weight',
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <HeightPage />,
        path: 'height',
      },

      // ============================================
      // EXERCISE BLOCK (3 pages)
      // ============================================
      {
        action: navigateToNextOnboardingPageAction,
        element: <ExerciseFrequencyPage />,
        path: 'exercise-frequency',
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <RunningDifficultyPage />,
        path: 'running-difficulty',
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <SittingTimePage />,
        path: 'sitting-time',
      },

      // ============================================
      // HABITS BLOCK (6 pages)
      // ============================================
      {
        action: navigateToNextOnboardingPageAction,
        element: <HabitsIntroPage />,
        path: 'habits-intro',
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <SmokingPage />,
        path: 'smoking',
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <AlcoholPage />,
        path: 'alcohol',
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <SleepHoursPage />,
        path: 'sleep',
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <StressPage />,
        path: 'stress',
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <SleepTroublePage />,
        path: 'sleep-trouble',
      },

      // ============================================
      // NUTRITION BLOCK (5 pages)
      // ============================================
      {
        action: navigateToNextOnboardingPageAction,
        element: <NutritionIntroPage />,
        path: 'nutrition-intro',
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <WaterIntakePage />,
        path: 'water-intake',
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <SugarIntakePage />,
        path: 'sugar-intake',
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <ProcessedFoodPage />,
        path: 'processed-food',
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <FruitsAndVeggiesPage />,
        path: 'fruits-and-veggies',
      },

      // ============================================
      // HEALTHCARE BLOCK (8 pages)
      // ============================================
      {
        action: navigateToNextOnboardingPageAction,
        element: <HealthcareIntroPage />,
        path: 'healthcare-intro',
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <GrandparentsLifespanPage />,
        path: 'grandparents-lifespan',
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <DoctorCheckupsPage />,
        path: 'doctor-checkups',
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <CancerScreeningsPage />,
        path: 'cancer-screenings',
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <BloodPressurePage />,
        path: 'blood-pressure',
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <CholesterolPage />,
        path: 'cholesterol',
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <BloodGlucosePage />,
        path: 'blood-glucose',
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <SunProtectionPage />,
        path: 'sun-protection',
      },

      // ============================================
      // SOCIAL BLOCK (7 pages)
      // ============================================
      {
        action: navigateToNextOnboardingPageAction,
        element: <SocialLifeIntroPage />,
        path: 'social-life-intro',
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <IncomeLevelPage />,
        path: 'income-level',
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <JobPage />,
        path: 'job',
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <LivingLocationPage />,
        path: 'living-location',
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <RelationshipStatusPage />,
        path: 'relationship-status',
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <SocialTimePage />,
        path: 'social-time',
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <ChildrenPage />,
        path: 'children',
      },
    ],
  },
]

export default onboardingRoutes
